import { render, staticRenderFns } from "./PageIns.vue?vue&type=template&id=61de9962&scoped=true&"
import script from "./PageIns.vue?vue&type=script&lang=js&"
export * from "./PageIns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61de9962",
  null
  
)

export default component.exports